(function () {
  var modal = document.getElementById('sceneModal');
  if (!modal) return;

  var modalImage = document.getElementById('modalImage');
  var modalTag = document.getElementById('modalTag');
  var modalTitle = document.getElementById('modalTitle');
  var modalDesc = document.getElementById('modalDesc');
  var modalProductsFieldset = document.getElementById('modalProducts');
  var modalTotalPrice = document.getElementById('modalTotalPrice');
  var modalSaveAmount = document.getElementById('modalSaveAmount');
  var modalCtaBtn = document.getElementById('modalCtaBtn');
  var modalCtaLabel = modalCtaBtn.querySelector('.wb-scene-cta-label');
  var modalSummaryMsg = document.getElementById('modalSummaryMsg');
  var modalDiscountBox = document.getElementById('modalDiscountBox');
  var modalDiscountStrength = document.getElementById('modalDiscountStrength');
  var modalDiscountCode = document.getElementById('modalDiscountCode');
  var discountCopyBtn = document.getElementById('discountCopyBtn');
  var heroPrevBtn = document.getElementById('heroPrevBtn');
  var heroNextBtn = document.getElementById('heroNextBtn');
  var heroDots = document.getElementById('heroDots');

  var fitmentModal = document.getElementById('fitmentModal');
  var fitmentContent = document.getElementById('fitmentContent');

  var IDLE_LABEL = 'ADD SELECTED TO CART';

  var currentScene = null;
  var currentSceneId = null;
  var currentSelected = [];
  var currentOptionIndex = [];
  var ctaState = 'idle'; // idle | loading | success | error

  var heroGallery = [];
  var heroIndex = 0;

  function firstAvailableOptionIndex(p) {
    var options = p.options || [];
    for (var i = 0; i < options.length; i++) {
      if (options[i].available) return i;
    }
    return 0;
  }

  function selectedOption(p, index) {
    var options = p.options || [];
    return options[currentOptionIndex[index]] || options[0] || {};
  }

  function openModal(blockId) {
    var scene = (window.sceneModalData || {})[blockId];
    if (!scene) return;

    currentScene = scene;
    currentSceneId = blockId;
    currentOptionIndex = scene.products.map(firstAvailableOptionIndex);
    currentSelected = scene.products.map(function (p, index) {
      return !!selectedOption(p, index).available && !!p.defaultChecked;
    });
    resetCtaState();

    if (scene.image) {
      modalImage.style.display = '';
    } else {
      modalImage.style.display = 'none';
    }
    modalImage.alt = scene.title || '';

    heroGallery = (scene.gallery && scene.gallery.length) ? scene.gallery : (scene.image ? [scene.image] : []);
    heroIndex = 0;
    showHeroImage();

    modalTag.textContent = scene.tag || '';
    modalTag.style.display = scene.tag ? '' : 'none';
    modalTitle.textContent = scene.title || '';
    modalDesc.textContent = scene.desc || '';
    modalDesc.style.display = scene.desc ? '' : 'none';

    if (scene.discountCode) {
      modalDiscountBox.style.display = 'block';
      modalDiscountCode.textContent = scene.discountCode;
      var minQty = scene.discountMinQty || 0;
      var percent = scene.discountPercent || 0;
      modalDiscountStrength.textContent =
        percent > 0 && minQty > 0 ? 'Buy ' + minQty + '+ items, save ' + percent + '%' : '';
    } else {
      modalDiscountBox.style.display = 'none';
    }

    renderOptions();
    recomputeTotals();

    modal.classList.add('wb-scene-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('wb-scene-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    resetCtaState();
  }

  function renderOptions() {
    if (!currentScene || !currentScene.products.length) {
      modalProductsFieldset.innerHTML =
        '<legend class="wb-scene-visually-hidden">Select products to add to cart</legend>' +
        '<p class="wb-scene-modal-empty">No products configured for this build yet.</p>';
      return;
    }

    var html = '<legend class="wb-scene-visually-hidden">Select products to add to cart</legend>';

    currentScene.products.forEach(function (p, index) {
      if (index > 0) {
        html += '<span class="wb-scene-modal-connector" aria-hidden="true">+</span>';
      }
      var options = p.options || [];
      var opt = selectedOption(p, index);
      var soldOut = !opt.available;
      var checked = currentSelected[index];
      var hasChoices = options.length > 1;

      html +=
        '<label class="wb-scene-modal-option' + (soldOut ? ' wb-scene-is-sold-out' : '') + '">' +
          '<input type="checkbox" class="wb-scene-modal-option-input" data-index="' + index + '"' +
            (checked ? ' checked' : '') + (soldOut ? ' disabled' : '') + ' />' +
          '<span class="wb-scene-modal-option-check" aria-hidden="true"></span>' +
          '<span class="wb-scene-modal-option-card">' +
            '<span class="wb-scene-modal-option-top">' +
              (opt.image
                ? '<img class="wb-scene-modal-option-image" src="' + escapeAttr(opt.image) + '" alt="" loading="lazy" />'
                : '<span class="wb-scene-modal-option-image wb-scene-modal-option-image-placeholder"></span>') +
              '<span class="wb-scene-modal-option-info">' +
                '<span class="wb-scene-modal-option-title">' + escapeHtml(p.title) + '</span>' +
                (opt.subtitle ? '<span class="wb-scene-modal-option-subtitle">' + escapeHtml(opt.subtitle) + '</span>' : '') +
                (hasChoices
                  ? '<select class="wb-scene-modal-option-vehicle" data-index="' + index + '">' +
                      options.map(function (o, oi) {
                        return '<option value="' + oi + '"' +
                          (oi === currentOptionIndex[index] ? ' selected' : '') +
                          (o.available ? '' : ' disabled') + '>' +
                          escapeHtml(o.label) + (o.available ? '' : ' — Sold out') +
                          '</option>';
                      }).join('') +
                    '</select>'
                  : '') +
                (opt.fitmentSectionId
                  ? '<button type="button" class="wb-scene-modal-option-fitment-link" data-handle="' + escapeAttr(opt.handle) + '" data-fitment-id="' + escapeAttr(opt.fitmentSectionId) + '" data-url="' + escapeAttr(opt.url) + '">' +
                      '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>' +
                      'Check fitment' +
                    '</button>'
                  : '') +
              '</span>' +
            '</span>' +
            '<span class="wb-scene-modal-option-bottom">' +
              (soldOut ? '<span class="wb-scene-modal-option-badge">Sold out</span>' : '<span></span>') +
              '<span class="wb-scene-modal-option-price">' + formatMoney(opt.priceCents) + '</span>' +
            '</span>' +
          '</span>' +
        '</label>';
    });

    modalProductsFieldset.innerHTML = html;
  }

  function showHeroImage() {
    if (heroGallery.length) {
      modalImage.src = heroGallery[heroIndex] || '';
    } else {
      modalImage.removeAttribute('src');
    }

    var hasMultiple = heroGallery.length > 1;
    heroPrevBtn.style.display = hasMultiple ? '' : 'none';
    heroNextBtn.style.display = hasMultiple ? '' : 'none';

    if (hasMultiple) {
      heroDots.innerHTML = heroGallery
        .map(function (_, i) {
          return '<span class="wb-scene-hero-dot' + (i === heroIndex ? ' wb-scene-is-active' : '') + '"></span>';
        })
        .join('');
    } else {
      heroDots.innerHTML = '';
    }
  }

  function showPrevHeroImage() {
    if (!heroGallery.length) return;
    heroIndex = (heroIndex - 1 + heroGallery.length) % heroGallery.length;
    showHeroImage();
  }

  function showNextHeroImage() {
    if (!heroGallery.length) return;
    heroIndex = (heroIndex + 1) % heroGallery.length;
    showHeroImage();
  }

  function onOptionChange(e) {
    var target = e.target;
    if (!target) return;

    if (target.classList.contains('wb-scene-modal-option-input')) {
      var idx = parseInt(target.getAttribute('data-index'), 10);
      if (isNaN(idx)) return;
      currentSelected[idx] = target.checked;
      recomputeTotals();
      return;
    }

    if (target.classList.contains('wb-scene-modal-option-vehicle')) {
      var vIdx = parseInt(target.getAttribute('data-index'), 10);
      var optIdx = parseInt(target.value, 10);
      if (isNaN(vIdx) || isNaN(optIdx)) return;
      currentOptionIndex[vIdx] = optIdx;
      renderOptions();
      recomputeTotals();
    }
  }

  function recomputeTotals() {
    if (!currentScene) return;

    var totalCents = 0;
    var compareCents = 0;
    var anySelected = false;
    var selectedCount = 0;

    currentScene.products.forEach(function (p, index) {
      var opt = selectedOption(p, index);
      if (currentSelected[index] && opt.available) {
        anySelected = true;
        selectedCount++;
        totalCents += opt.priceCents;
        compareCents += opt.compareAtCents > opt.priceCents ? opt.compareAtCents : opt.priceCents;
      }
    });

    modalTotalPrice.textContent = formatMoney(totalCents);

    var saveCents = compareCents - totalCents;

    var minQty = currentScene.discountMinQty || 0;
    var percent = currentScene.discountPercent || 0;
    if (percent > 0 && minQty > 0 && selectedCount >= minQty) {
      saveCents += Math.round((totalCents * percent) / 100);
    }

    if (saveCents > 0) {
      modalSaveAmount.textContent = 'You save ' + formatMoney(saveCents);
      modalSaveAmount.style.display = '';
    } else {
      modalSaveAmount.style.display = 'none';
    }

    modalCtaBtn.disabled = !anySelected || ctaState === 'loading';
  }

  function resetCtaState() {
    ctaState = 'idle';
    modalCtaBtn.classList.remove('wb-scene-is-loading', 'wb-scene-is-success', 'wb-scene-is-error');
    modalCtaLabel.textContent = IDLE_LABEL;
    modalSummaryMsg.textContent = '';
    modalSummaryMsg.classList.remove('wb-scene-is-error');
  }

  function handleAddToCart() {
    if (ctaState === 'loading' || !currentScene) return;

    var items = [];
    currentScene.products.forEach(function (p, index) {
      var opt = selectedOption(p, index);
      if (currentSelected[index] && opt.available && opt.id) {
        items.push({ id: opt.id, quantity: 1 });
      }
    });
    if (!items.length) return;

    ctaState = 'loading';
    modalCtaBtn.disabled = true;
    modalCtaBtn.classList.remove('wb-scene-is-success', 'wb-scene-is-error');
    modalCtaBtn.classList.add('wb-scene-is-loading');
    modalCtaLabel.textContent = 'ADDING...';
    modalSummaryMsg.textContent = '';
    modalSummaryMsg.classList.remove('wb-scene-is-error');

    // Ask Shopify to return the theme's re-rendered cart sections along with
    // the add, so the header badge (and the drawer, if the theme exposes its
    // renderer) can update from one request instead of a second round trip.
    var body = { items: items };
    var sections = cartSectionsToRequest();
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            throw new Error((data && data.description) || 'Could not add to cart.');
          }
          return data;
        });
      })
      .then(function (cart) {
        ctaState = 'success';
        modalCtaBtn.classList.remove('wb-scene-is-loading');
        modalCtaBtn.classList.add('wb-scene-is-success');
        modalCtaLabel.textContent = 'ADDED!';
        modalCtaBtn.disabled = false;

        document.dispatchEvent(
          new CustomEvent('wb-scene-bundle:added', {
            detail: { cart: cart, items: items, sceneId: currentSceneId }
          })
        );

        var section = document.querySelector('.wb-scene-section');
        var shouldRedirect = section && section.getAttribute('data-redirect-to-cart') === 'true';

        if (shouldRedirect) {
          // Heading to /cart anyway — that page renders the fresh cart itself,
          // so refreshing the header here would just be an aborted request.
          modalSummaryMsg.textContent = 'Added! Redirecting to your cart...';
          setTimeout(function () {
            window.location.href = '/cart';
          }, 900);
        } else {
          refreshCartUI(cart);
          cartChangedSinceLoad = true;
          modalSummaryMsg.textContent = 'Added to your cart.';
          setTimeout(function () {
            if (ctaState === 'success') resetCtaState();
          }, 1800);
        }
      })
      .catch(function (err) {
        ctaState = 'error';
        modalCtaBtn.classList.remove('wb-scene-is-loading');
        modalCtaBtn.classList.add('wb-scene-is-error');
        modalCtaLabel.textContent = IDLE_LABEL;
        modalCtaBtn.disabled = false;
        modalSummaryMsg.textContent = (err && err.message) || 'Something went wrong. Please try again.';
        modalSummaryMsg.classList.add('wb-scene-is-error');
      });
  }

  /* ------------------------------------------------------------------
     Cart UI refresh — /cart/add.js returns only the line items just added,
     so nothing tells the theme's header that the cart changed and the badge
     stays stale until a reload, which reads as "the cart took ages".

     IMPORTANT — two things we deliberately do NOT do, both learned the hard way:
     1. We never replace the <cart-drawer> element's innerHTML. Its listeners are
        bound in connectedCallback, which does not re-run, so the drawer stops
        opening entirely.
     2. We never call the theme's renderContents(). That method writes each
        section into a selector from its own getSectionsToRender() list; if any
        id/selector doesn't line up with what Shopify returned, it writes empty
        strings into the drawer and leaves the .is-empty class on — a drawer that
        opens but shows nothing, even though the cart has items.

     So we only ever touch the header count badge, which is markup we can see in
     header.liquid and which no theme JS has bound behaviour to. The drawer is
     left for the theme to populate the way it normally does.
  ------------------------------------------------------------------ */
  var cartRefreshToken = 0;

  // Only the badge section — deliberately NOT the drawer's section list, since
  // we don't render the drawer ourselves.
  function cartSectionsToRequest() {
    return ['cart-icon-bubble'];
  }

  function patchCartBubbleFromSections(cart) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return false;
    var html = cart && cart.sections && cart.sections['cart-icon-bubble'];
    if (!html) return false;
    var fresh;
    try {
      fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-count-bubble');
    } catch (e) {
      return false;
    }
    // We only run this right after a successful add, so the cart can't be
    // empty. A missing bubble means the section rendered unexpectedly —
    // fall back rather than wrongly deleting the badge.
    if (!fresh) return false;
    var existing = icon.querySelector('.cart-count-bubble');
    if (existing) {
      existing.parentNode.replaceChild(fresh, existing);
    } else {
      icon.appendChild(fresh);
    }
    return true;
  }

  function patchCartBubbleCount(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        // header.liquid only renders the bubble when the cart is non-empty,
        // so on the first add of a session we have to create it.
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble font-bold';
        icon.appendChild(bubble);
      }
      var visible = bubble.querySelector('[aria-hidden="true"]');
      if (!visible) {
        visible = document.createElement('span');
        visible.setAttribute('aria-hidden', 'true');
        bubble.appendChild(visible);
      }
      visible.textContent = count;
      if (count > 999) {
        visible.setAttribute('style', 'font-size: 8px; white-space: nowrap;');
      } else {
        visible.removeAttribute('style');
      }
      // Leave any existing .visually-hidden sibling alone — it holds the
      // theme's translated "N items" string and we have no translation here.
    } else if (bubble) {
      bubble.parentNode.removeChild(bubble);
    }
  }

  function refreshCartUI(cart) {
    var token = ++cartRefreshToken;

    // Preferred: the badge markup Shopify re-rendered for us, already translated.
    if (patchCartBubbleFromSections(cart)) return;

    // Otherwise read the authoritative count and patch the badge by hand.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (fresh) {
        // A slower earlier refresh must never overwrite a newer count.
        if (fresh && token === cartRefreshToken) patchCartBubbleCount(fresh.item_count);
      })
      .catch(function () {
        /* best effort only — the add itself already succeeded */
      });
  }

  /* Safety net. We refuse to rewrite the drawer's contents (see the note above),
     so on a theme whose drawer only renders server-side at page load, it would
     still be showing the pre-add state. Most Dawn-derived drawers refetch
     themselves when opened, so we do NOT pre-emptively reload — that would
     wreck the normal experience. Instead we look at the drawer just after it
     opens, and only fall back to a reload if it is actually showing an empty
     cart while we know items were added. */
  var cartChangedSinceLoad = false;

  function drawerLooksEmpty(drawer) {
    if (drawer.classList.contains('is-empty')) return true;
    var inner = drawer.querySelector('.drawer__inner, .cart-drawer__inner');
    // A populated drawer always renders at least one line item.
    return !!inner && !drawer.querySelector('.cart-item, cart-drawer-items .cart-item');
  }

  function verifyDrawerAfterOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !cartChangedSinceLoad) return;
    // Give the theme's own open/refetch animation time to finish first.
    setTimeout(function () {
      if (!cartChangedSinceLoad) return;
      if (!drawer.classList.contains('active') && !drawer.classList.contains('is-open')) return;
      if (!drawerLooksEmpty(drawer)) {
        // Theme refreshed itself correctly — stand down for good.
        cartChangedSinceLoad = false;
        return;
      }
      cartChangedSinceLoad = false;
      window.location.reload();
    }, 700);
  }

  var cartIconEl = document.getElementById('cart-icon-bubble');
  if (cartIconEl) cartIconEl.addEventListener('click', verifyDrawerAfterOpen);

  function formatMoney(cents) {
    cents = cents || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, window.sceneModalMoneyFormat);
      } catch (e) {
        /* fall through to local formatter */
      }
    }
    var format = window.sceneModalMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100).toString();
    return format
      .replace('{{amount}}', amount)
      .replace('{{ amount }}', amount)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{ amount_no_decimals }}', amountNoDecimals);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/"/g, '&quot;');
  }

  /* ------------------------------------------------------------------
     Fitment — fetch the Fitment block off a product's own page and
     show it inline, cached in localStorage. We already know each
     product's exact section id (from its metafield), so this skips
     the id-guessing/probing logic and just fetches that one section.
  ------------------------------------------------------------------ */
  var FIT_RE = /^(fitment|fitment information|fitment info|fits|compatibility|vehicle fitment)$/i;
  var FIT_CACHE_HOURS = 24;
  var FIT_HTML_PREFIX = 'wb-scene-fitment-html-v1:';
  var fitMem = {};
  var fitPending = {};

  function lsGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function lsSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* storage full or unavailable — just skip caching */
    }
  }

  function fitCacheGet(handle) {
    var raw = lsGet(FIT_HTML_PREFIX + handle);
    if (!raw) return null;
    try {
      var o = JSON.parse(raw);
      if (!o || typeof o.h !== 'string') return null;
      if (new Date().getTime() - (o.t || 0) > FIT_CACHE_HOURS * 3600000) return null;
      return o.h;
    } catch (e) {
      return null;
    }
  }

  function fitCacheSet(handle, html) {
    if (!html || html.length > 200000) return;
    lsSet(FIT_HTML_PREFIX + handle, JSON.stringify({ t: new Date().getTime(), h: html }));
  }

  function scoreFitBlock(el) {
    if (!el) return 0;
    var tag = el.tagName;
    if (tag === 'BODY' || tag === 'HTML' || tag === 'MAIN') return 0;
    var txt = el.textContent || '';
    if (txt.length > 12000) return 0;
    return (el.querySelector('table') ? 2 : 0) + (/fitment|compatib/i.test(txt.slice(0, 600)) ? 1 : 0);
  }

  function containerWithTable(heading) {
    var node = heading.parentElement;
    var guard = 0;
    while (node && guard++ < 6) {
      if (node.tagName === 'BODY' || node.tagName === 'HTML' || node.tagName === 'MAIN') return null;
      if (node.querySelector('table')) return node;
      node = node.parentElement;
    }
    return null;
  }

  function findFitmentBlock(doc) {
    var heads = doc.querySelectorAll('h1,h2,h3,h4,h5,.h1,.h2,.h3,.h4,[class*="title"],[class*="heading"]');
    var fallback = null;
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      if (!FIT_RE.test((h.textContent || '').trim())) continue;
      if (h.closest && h.closest('a, nav, button, [role="navigation"], [role="tablist"]')) continue;
      var box = containerWithTable(h);
      if (box) return box;
      if (!fallback && h.parentElement && scoreFitBlock(h.parentElement)) fallback = h.parentElement;
    }
    return fallback;
  }

  function cleanFitmentBlock(el) {
    var clone = el.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('script, noscript, iframe, form'), function (n) {
      n.parentNode.removeChild(n);
    });
    Array.prototype.forEach.call(clone.querySelectorAll('details'), function (d) {
      d.open = true;
    });
    Array.prototype.forEach.call(clone.querySelectorAll('img'), function (im) {
      var ds = im.getAttribute('data-src') || im.getAttribute('data-srcset');
      if (!im.getAttribute('src') && ds) im.setAttribute('src', ds.split(' ')[0]);
      im.removeAttribute('loading');
    });
    var styles = '';
    var wrap = el.closest ? el.closest('.shopify-section') : null;
    if (wrap && wrap !== el) {
      styles = Array.prototype.map
        .call(wrap.querySelectorAll('style, link[rel="stylesheet"]'), function (s) {
          return s.outerHTML;
        })
        .join('');
    }
    return styles + clone.outerHTML;
  }

  function parseFitmentHtml(html) {
    if (!html || html.length < 40) return '';
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = findFitmentBlock(doc);
    if (!el || !scoreFitBlock(el)) return '';
    return cleanFitmentBlock(el);
  }

  function probeFitmentSection(handle, sectionId) {
    return fetch('/products/' + handle + '?section_id=' + encodeURIComponent(sectionId), {
      headers: { Accept: 'text/html' }
    })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(parseFitmentHtml)
      .catch(function () {
        return '';
      });
  }

  function fitmentFromFullPage(handle) {
    return fetch('/products/' + handle, { headers: { Accept: 'text/html' } })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(parseFitmentHtml)
      .catch(function () {
        return '';
      });
  }

  function fetchFitment(handle, sectionId) {
    if (!handle) return Promise.resolve('');
    if (fitMem[handle] !== undefined) return Promise.resolve(fitMem[handle]);
    if (fitPending[handle]) return fitPending[handle];

    var cached = fitCacheGet(handle);
    if (cached) {
      fitMem[handle] = cached;
      return Promise.resolve(cached);
    }

    var resolve = sectionId
      ? probeFitmentSection(handle, sectionId).then(function (html) {
          return html || fitmentFromFullPage(handle);
        })
      : fitmentFromFullPage(handle);

    var promise = resolve.then(function (found) {
      found = found || '';
      fitMem[handle] = found;
      fitCacheSet(handle, found);
      delete fitPending[handle];
      return found;
    });
    fitPending[handle] = promise;
    return promise;
  }

  function showFitmentModal() {
    if (!fitmentModal) return;
    fitmentModal.classList.add('wb-scene-active');
    fitmentModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function hideFitmentModal() {
    if (!fitmentModal) return;
    fitmentModal.classList.remove('wb-scene-active');
    fitmentModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = modal.classList.contains('wb-scene-active') ? 'hidden' : '';
  }

  function paintFitment(html, productUrl) {
    if (!fitmentContent) return;
    if (!html) {
      fitmentContent.innerHTML =
        '<p class="wb-scene-fitment-empty">Fitment info isn\'t available for this product yet.' +
        (productUrl ? ' <a href="' + escapeAttr(productUrl) + '" target="_blank" rel="noopener">View product page</a>' : '') +
        '</p>';
      return;
    }
    fitmentContent.innerHTML = '<div class="wb-scene-fitment-inner">' + html + '</div>';
  }

  function openFitment(handle, sectionId, productUrl) {
    if (!handle) {
      if (productUrl) window.open(productUrl, '_blank');
      return;
    }
    showFitmentModal();
    if (fitMem[handle] !== undefined) {
      paintFitment(fitMem[handle], productUrl);
    } else {
      fitmentContent.innerHTML =
        '<div class="wb-scene-fitment-skeleton"><span></span><span></span><span></span><span></span></div>';
      fetchFitment(handle, sectionId).then(function (html) {
        paintFitment(html, productUrl);
      });
    }
  }

  function onCopyDiscount() {
    var code = modalDiscountCode.textContent;
    var textEl = discountCopyBtn.querySelector('.wb-scene-copy-text');
    try {
      var textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      textEl.textContent = 'COPIED!';
      setTimeout(function () {
        textEl.textContent = 'COPY';
      }, 2000);
    } catch (err) {
      textEl.textContent = 'COPY';
    }
  }

  /* ------------------------------------------------------------------
     Card galleries — each card shows the same image set as the modal's hero
     carousel. Slides cross-fade in place; arrows and dots sit on top of the
     photo. Nav clicks must not bubble to the card's "shop the build" trigger.
  ------------------------------------------------------------------ */
  function initCardGallery(galleryEl) {
    var slides = galleryEl.querySelectorAll('.wb-scene-card-slide');
    if (slides.length < 2) return;
    var dots = galleryEl.querySelectorAll('[data-card-dot]');
    var index = 0;

    function show(next) {
      index = (next + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) {
        slides[s].classList.toggle('wb-scene-is-active', s === index);
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('wb-scene-is-active', d === index);
      }
    }

    galleryEl.addEventListener('click', function (e) {
      var target = e.target;
      var hit = target.closest && target.closest('[data-card-prev], [data-card-next], [data-card-dot]');
      if (!hit) return;
      // The whole card opens the modal on click — keep gallery nav local.
      e.preventDefault();
      e.stopPropagation();
      if (hit.hasAttribute('data-card-prev')) {
        show(index - 1);
      } else if (hit.hasAttribute('data-card-next')) {
        show(index + 1);
      } else {
        var to = parseInt(hit.getAttribute('data-card-dot'), 10);
        if (!isNaN(to)) show(to);
      }
    });

    // Swipe support for touch devices, where the arrows are less discoverable.
    var startX = null;
    galleryEl.addEventListener(
      'touchstart',
      function (e) {
        startX = e.touches && e.touches.length === 1 ? e.touches[0].clientX : null;
      },
      { passive: true }
    );
    galleryEl.addEventListener(
      'touchend',
      function (e) {
        if (startX === null) return;
        var endX = e.changedTouches && e.changedTouches.length ? e.changedTouches[0].clientX : null;
        var delta = endX === null ? 0 : endX - startX;
        startX = null;
        if (Math.abs(delta) < 40) return; // treat small movement as a tap
        show(delta < 0 ? index + 1 : index - 1);
      },
      { passive: true }
    );
  }

  var cardGalleries = document.querySelectorAll('[data-card-gallery]');
  for (var g = 0; g < cardGalleries.length; g++) {
    initCardGallery(cardGalleries[g]);
  }

  var triggers = document.querySelectorAll('.wb-scene-modal-trigger');
  for (var i = 0; i < triggers.length; i++) {
    triggers[i].addEventListener('click', function () {
      openModal(this.getAttribute('data-block-id'));
    });
  }

  var closeEls = document.querySelectorAll('[data-modal-close]');
  for (var j = 0; j < closeEls.length; j++) {
    closeEls[j].addEventListener('click', closeModal);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (fitmentModal && fitmentModal.classList.contains('wb-scene-active')) {
      hideFitmentModal();
      return;
    }
    if (modal.classList.contains('wb-scene-active')) closeModal();
  });

  modalProductsFieldset.addEventListener('change', onOptionChange);
  modalProductsFieldset.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.wb-scene-modal-option-fitment-link');
    if (!btn) return;
    openFitment(btn.getAttribute('data-handle'), btn.getAttribute('data-fitment-id'), btn.getAttribute('data-url'));
  });
  modalCtaBtn.addEventListener('click', handleAddToCart);
  if (discountCopyBtn) discountCopyBtn.addEventListener('click', onCopyDiscount);
  if (heroPrevBtn) heroPrevBtn.addEventListener('click', showPrevHeroImage);
  if (heroNextBtn) heroNextBtn.addEventListener('click', showNextHeroImage);

  var fitmentCloseEls = fitmentModal ? fitmentModal.querySelectorAll('[data-fitment-close]') : [];
  for (var k = 0; k < fitmentCloseEls.length; k++) {
    fitmentCloseEls[k].addEventListener('click', hideFitmentModal);
  }
})();
